<template>
  <div class="trading list-container">
    <van-nav-bar fixed left-arrow title="账单" @click-left="$router.replace({ path: '/user' })" :z-index="10" @click-right="onRight">
      <!-- <template #right>
        <van-icon :name="nav_right_icon" size="20"></van-icon>
      </template> -->
    </van-nav-bar>
    <div class="header" style="z-index: 2">
      <div class="contain">
        <van-sticky offset-top="46">
          <van-dropdown-menu class="dropdownmenu-bg">
            <van-dropdown-item v-model="fundType" :options="fundTypes" />
            <!-- <van-dropdown-item v-model="time" :options="times" /> -->
          </van-dropdown-menu>
        </van-sticky>
        <div class="calendar" @click="onRight">
          <!-- <van-icon :name="nav_right_icon" size="20" @click="onRight"> </van-icon> -->
          日期选择
        </div>
      </div>
    </div>

    <van-pull-refresh class="list-contain" v-model="refreshing" @refresh="onRefresh">
      <!-- <van-list
        v-model="loading"
        :immediate-check="false"
        :finished="finished"
        finished-text="没有更多了"
        @load="onGetList" :offset="10"> -->
      <van-list class="list" v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="error" error-text="请求失败，点击重新加载" @load="onGetList" :offset="10">
        <van-cell class="trading-list item" v-for="(item, index) in list" :key="index">
          <!-- <div class="trading-list-item">
            <div class="trading-list-item-a">交易流水号 {{ item.id }}</div>
            <div class="trading-list-item-b">{{ item.amount | numFormat }}</div>
          </div>
          <div class="trading-list-item">
            <div class="trading-list-item-c">{{ item.createTime }}</div>
            <div class="trading-list-item-d">
              {{ getFundType(item.fundType) }}
            </div>
          </div> -->
          <div class="item-bg">
            <div class="title">交易流水号：{{ item.id }}</div>
            <div class="amount">金额：{{ item.amount | numFormat }}元</div>
            <div class="create-time">流水时间：{{ item.createTime }}</div>
            <div class="tag" :style="getFundTypeColor(item.fundType)">
              {{ getFundType(item.fundType) }}
            </div>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
    <!-- 展示日期选择面板 -->
    <van-action-sheet :z-index="99" v-model="isShowSheet" title="日期选择">
      <div class="sheet-bg">
        <!-- 列表信息 -->
        <van-cell-group class="options-list">
          <!-- 开始时间 -->
          <van-cell is-link v-for="(item, index) in dateList" :key="index" :class="['menu', index == dateList.length - 1 ? 'last' : '']" :title="item.title" :value="item.subTitle" :formatter="formatter" @click="onClickItem(item)">
          </van-cell>
        </van-cell-group>
        <van-button class="sure-btn" block @click="onSure">确定</van-button>
        <van-button class="reset-btn" block @click="onReset">重置</van-button>
        <!-- 展示时间选择器 -->
        <van-overlay :show="isShowDatePicker" :z-index="100">
          <div class="datetime-bg">
            <van-datetime-picker v-model="currentDate" type="date" :title="dateTitle" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm" @cancel="onCancel"></van-datetime-picker>
          </div>
        </van-overlay>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {
  DropdownMenu,
  DropdownItem,
  NavBar,
  List,
  Cell,
  Sticky,
  Toast,
  Dialog,
  PullRefresh,
  DatetimePicker,
  Overlay,
  Icon,
  ActionSheet,
  CellGroup
} from "vant"
import * as TradingApi from "@/api/trading"
import rightImg from "../../assets/img/my-order/calendar.png"
export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [Cell.name]: Cell,
    [Sticky.name]: Sticky,
    [PullRefresh.name]: PullRefresh,
    [ActionSheet.name]: ActionSheet,
    [DatetimePicker.name]: DatetimePicker,
    [Overlay.name]: Overlay,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },

  data() {
    return {
      nav_right_icon: rightImg,
      fundType: 0,
      time: "all",
      pageSize: 10,
      pageNo: 1,
      fundTypes: [
        { text: "全部", value: 0 },
        { text: "充值", value: 1 },
        { text: "认购", value: 2 },
        { text: "提现", value: 3 },
        { text: "兑付", value: 4 },
        { text: "撤销", value: 7 },
        { text: "支付", value: 8 },
        { text: "退款", value: 9 },
        { text: "返现", value: 10 },
      ],
      times: [
        { text: "所有月份", value: "all" },
        { text: "三月", value: "three" },
        { text: "六月", value: "six" },
        { text: "一年", value: "twelve" }
      ],

      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      open_page: true, //  是否为第一次打开页面

      tempBeginTime: "",
      tempEndTime: "",
      dateObj: {},
      isShowSheet: false,
      isShowDatePicker: false,
      minDate: new Date(2000, 1, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      dateTitle: "",
      dateList: [
        { title: "开始时间", subTitle: "请选择" },
        { title: "结束时间", subTitle: "请选择" }
      ]
    }
  },

  created() {
    // 确认是否登录
    if (this._confirmLogin({ mustLogin: true })) {
      this.onGetList(0)
    }
  },

  watch: {
    fundType(newVal, oldVal) {
      this.pageNo = 1
      this.onGetList(1)
    },
    time(newVal, oldVal) {
      this.pageNo = 1
      this.onGetList(1)
    },
    dateObj(value, oldvalue) {
      this.pageNo = 1
      this.onGetList(1)
    }
  },

  methods: {
    showsss() {
      this.isShowSheet = true
    },
    onRight() {
      this.isShowSheet = true
    },
    onClickItem(item) {
      this.isShowDatePicker = true
      this.dateTitle = item.title
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年"
      }
      if (type === "month") {
        return val + "月"
      }
      if (type === "day") {
        return val + "日"
      }
      return val
    },
    onCancel() {
      this.isShowDatePicker = false
    },
    onConfirm(value) {
      if (this.dateTitle == "开始时间") {
        if (this.tempEndTime) {
          if (
            this.estimateRegisterationTime(
              this.timeFormat(value),
              this.tempEndTime
            )
          ) {
            this.tempBeginTime = this.timeFormat(value)
            this.dateList[0]["subTitle"] = this.tempBeginTime
          }
        } else {
          this.isShowDatePicker = false
          this.tempBeginTime = this.timeFormat(value)
          this.dateList[0]["subTitle"] = this.tempBeginTime
        }
      } else if (this.dateTitle == "结束时间") {
        if (this.tempBeginTime) {
          if (
            this.estimateRegisterationTime(
              this.tempBeginTime,
              this.timeFormat(value)
            )
          ) {
            this.tempEndTime = this.timeFormat(value)
            this.dateList[1]["subTitle"] = this.tempEndTime
          }
        } else {
          this.isShowDatePicker = false
          this.tempEndTime = this.timeFormat(value)
          this.dateList[1]["subTitle"] = this.tempEndTime
        }
      }
    },
    timeFormat(time) {
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      if (month < 10) {
        month = "0" + month
      }
      let day = time.getDate()
      return year + "-" + month + "-" + day
    },
    // 判断两个日期是否在一年以内
    estimateRegisterationTime(beginDate, endDate) {
      let begin = new Date(beginDate).getTime()
      let end = new Date(endDate).getTime()
      let day = (end - begin) / (24 * 60 * 60 * 1000)
      if (day > 365) {
        this.$toast("只能选择一年以内的时间，请重新选择")
        return false
      } else {
        if (day < 0) {
          this.$toast("结束时间要大于等于开始时间，请重新选择")
          return false
        } else {
          this.isShowDatePicker = false
          return true
        }
      }
    },
    onSure() {
      // this.$refs.itemDate.toggle()
      this.isShowSheet = false
      this.dateObj = {
        beginTime: this.tempBeginTime,
        endTime: this.tempEndTime
      }
    },
    onReset() {
      this.isShowSheet = false
      this.tempBeginTime = ""
      this.tempEndTime = ""
      this.dateObj = {
        beginTime: "",
        endTime: ""
      }
      this.dateList[0]["subTitle"] = "请选择"
      this.dateList[1]["subTitle"] = "请选择"
    },
    onRefresh() {
      this.pageNo = 1
      this.onGetList()
    },
    /**
     * 获得 交易列表
     * @params isreset 为1表示重置 list 数据 , 为 0表示初始化的第一次请求
     */
    onGetList(isreset) {
      if (this.open_page && isreset === undefined) {
        // vant 垃圾 , 有坑 , 累计会被调用两次
        this.open_page = false
        return
      }

      let form = {
        fundType: this.fundType,
        time: this.time,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        beginTime: this.dateObj["beginTime"],
        endTime: this.dateObj["endTime"]
      }
      TradingApi.getFundRecord(form)
        .then((data) => {
          if (data) {
            this.loading = false

            if (isreset === 1) {
              document.body.scrollTop = 0
              document.documentElement.scrollTop = 0
              this.list = []
            }
            if (this.pageNo === 1) {
              this.finished = false
              this.list = data.list
              //赋值给数据源
            } else {
              this.list = this.list.concat(data.list)
            }
            if (data.list.length < this.pageSize) {
              this.finished = true
            } else {
              this.pageNo++
            }
            this.refreshing = false
          }
        })
        .catch((e) => {
          this.loading = false
          this.error = true
          if (e) {
            Toast(e.msg || e.message)
          }
        })
    },

    getFundType(fundType) {
      switch (fundType) {
        case 1:
          return "充值"
        case 2:
          return "认购"
        case 3:
          return "提现"
        case 4:
          return "兑付"
        case 5:
          return "提现申请"
        case 7:
          return "撤销"
        case 8:
          return "支付"
        case 9:
          return "退款"
        case 10:
          return "返现"
        default:
          break
      }
    },
    getFundTypeColor(fundType) {
      switch (fundType) {
        case 1:
          return "background-color: rgb(252, 102, 87)"
        case 2:
          return "background-color: rgb(100, 209, 159)"
        case 3:
          return "background-color: rgb(253, 181, 87)"
        case 4:
          return "background-color: rgb(0, 154, 199)"
        case 5:
          return "background-color: rgb(253, 181, 87)"
        case 7:
          return "background-color: rgb(151, 151, 151)"
        default:
          return "background-color: rgb(121, 121, 121)"
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 此页面不能使用 scoped
.trading {
  position: relative;
  background-color: #f1f5f8;
  min-height: 100vh;

  .header {
    position: fixed;
    top: 46px;
    width: 100%;
    .contain {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: white;
      // Firefox4.0-
      -moz-box-shadow: 2px 2px 10px rgb(212, 214, 211);
      // Safariand Google chrome10.0-
      -webkit-box-shadow: 2px 2px 10px rgb(212, 214, 211);
      // Firefox4.0+、Google Chrome 10.0+、Oprea10.5+ and IE9
      box-shadow: 2px 2px 10px rgb(212, 214, 211);
      .dropdownmenu-bg {
        width: 50vw;
      }
      .calendar {
        font-size: 16px;
        font-weight: 400;
        width: 50vw;
        text-align: center;
      }
    }
  }
  .list-contain {
    margin-top: 95px;
  }
  .van-cell {
    padding: 0;
    width: calc(100% - 30px);
  }

  .item {
    margin: 15px 15px 0 15px;
    border-radius: 8px;
    .item-bg {
      padding: 0 10px;
      .title {
        margin-top: 10px;
        font-size: 15px;
        font-weight: 500;
      }
      .amount {
        color: black;
        color: rgb(102, 102, 102);
        font-size: 14px;
        margin-top: 15px;
      }
      .order-num {
        margin-top: 5px;
        color: rgb(102, 102, 102);
        font-size: 14px;
      }
      .create-time {
        margin-top: 5px;
        margin-bottom: 15px;
        color: rgb(167, 167, 167);
        font-size: 12px;
      }

      .tag {
        position: absolute;
        right: 0;
        top: 12px;
        background-color: rgb(100, 209, 159);
        height: 24px;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 12px;
        padding: 0px 15px;
      }
    }
  }
  .options-list {
    // 下边框线条
    ::v-deep .van-cell.menu:not(:last-child)::after {
      border: none;
    }
    ::v-deep .van-cell {
      border-bottom: 1px solid #ebebeb;
      padding: 10px 15px;
      .van-cell__title {
        color: #666;
        font-size: 15px;
      }
    }
    .last {
      border: none;
    }
  }
  .sure-btn {
    margin-top: 50px;
    left: 15px;
    width: calc(100vw - 30px);
    height: 44px;
    border: 1px solid rgb(226, 152, 56);
    border-radius: 6px;
    color: rgb(226, 152, 56);
  }
  .reset-btn {
    margin-top: 15px;
    margin-bottom: 34px;
    left: 15px;
    width: calc(100vw - 30px);
    height: 44px;
    border: 1px solid rgb(151, 151, 151);
    border-radius: 6px;
    color: rgb(151, 151, 151);
  }
  .datetime-bg {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
  }
}
</style>
